<span class="download-link-wrapper">
  <a
    (click)="downloadFile(); $event.preventDefault()"
    [title]="tooltipText ? tooltipText : ('Download' | tekstresource: { fileName: displayText })"
  >
    {{ displayText }}
  </a>
  <bom-spinner
    class="spinner-floating"
    size="small"
    [style.visibility]="(isDownloading$ | async) ? 'visible' : 'hidden'"
  ></bom-spinner>
</span>
